import { render, staticRenderFns } from "./GerneralInformation.vue?vue&type=template&id=0dfb083c&scoped=true&"
import script from "./GerneralInformation.vue?vue&type=script&lang=js&"
export * from "./GerneralInformation.vue?vue&type=script&lang=js&"
import style0 from "./GerneralInformation.vue?vue&type=style&index=0&id=0dfb083c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dfb083c",
  null
  
)

export default component.exports